// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: gZEhwnQAfx2q6zBpBNhhDQ
// Component: klpgYFOobDsk
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  hasVariant,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import CreateNew from "../../CreateNew"; // plasmic-import: Q0aOqKnaVDqy/component
import CreateNewElement from "../../CreateNewElement"; // plasmic-import: 2Bdvl1-Hq6hK/component
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_collect_wise_draft.module.css"; // plasmic-import: gZEhwnQAfx2q6zBpBNhhDQ/projectcss
import sty from "./PlasmicCreateNewStack.module.css"; // plasmic-import: klpgYFOobDsk/css

createPlasmicElementProxy;

export const PlasmicCreateNewStack__VariantProps = new Array("postClick");

export const PlasmicCreateNewStack__ArgProps = new Array();

const $$ = {};

function PlasmicCreateNewStack__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "postClick",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.postClick
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });
  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        sty.root,
        { [sty.rootpostClick]: hasVariant($state, "postClick", "postClick") }
      )}
    >
      <CreateNew
        data-plasmic-name={"createNewButton"}
        data-plasmic-override={overrides.createNewButton}
        className={classNames("__wab_instance", sty.createNewButton, {
          [sty.createNewButtonpostClick]: hasVariant(
            $state,
            "postClick",
            "postClick"
          )
        })}
      />

      <CreateNewElement
        data-plasmic-name={"createNewElement"}
        data-plasmic-override={overrides.createNewElement}
        className={classNames("__wab_instance", sty.createNewElement, {
          [sty.createNewElementpostClick]: hasVariant(
            $state,
            "postClick",
            "postClick"
          )
        })}
      />
    </div>
  );
}

const PlasmicDescendants = {
  root: ["root", "createNewButton", "createNewElement"],
  createNewButton: ["createNewButton"],
  createNewElement: ["createNewElement"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicCreateNewStack__ArgProps,
          internalVariantPropNames: PlasmicCreateNewStack__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicCreateNewStack__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicCreateNewStack";
  } else {
    func.displayName = `PlasmicCreateNewStack.${nodeName}`;
  }
  return func;
}

export const PlasmicCreateNewStack = Object.assign(
  // Top-level PlasmicCreateNewStack renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    createNewButton: makeNodeComponent("createNewButton"),
    createNewElement: makeNodeComponent("createNewElement"),
    // Metadata about props expected for PlasmicCreateNewStack
    internalVariantProps: PlasmicCreateNewStack__VariantProps,
    internalArgProps: PlasmicCreateNewStack__ArgProps
  }
);

export default PlasmicCreateNewStack;
/* prettier-ignore-end */
